import { render, staticRenderFns } from "./productGrouping.vue?vue&type=template&id=8e76bb02&scoped=true&"
import script from "./productGrouping.vue?vue&type=script&lang=js&"
export * from "./productGrouping.vue?vue&type=script&lang=js&"
import style0 from "./productGrouping.vue?vue&type=style&index=0&id=8e76bb02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e76bb02",
  null
  
)

export default component.exports